/**
 * Navn → slug for tabeller med en `slug`-kolonne (mapper i dokumentarkivet,
 * tilgangsgrupper).
 *
 * Lå tidligere inline i `useCreateDocumentFolder`. Flyttet hit i VIB-2726 fordi
 * gruppene trenger den samme regelen, og to kopier av en slug-regel betyr at to
 * tabeller kan begynne å normalisere navn ulikt uten at noen merker det.
 *
 * Æ/Ø/Å translittereres eksplisitt — `normalize("NFD")` ville gjort «å» til
 * «a», men også «ø» til «ø» (den har ingen dekomponering), så en generisk
 * aksent-stripping ville gitt tomme slugger for rene norske navn.
 */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/æ/g, "ae")
    .replace(/ø/g, "o")
    .replace(/å/g, "a")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
